import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { IsAuthenticatedGuard } from './core/auth/guards/is-authenticated.guard'
import { IsNotAuthenticatedGuard } from './core/auth/guards/is-not-authenticated.guard'

// Define the routes for the application
const routes: Routes = [
  // EXISTING ROUTES (for regular users without organization context)
  {
    path: 'auth', // Route path for authentication module
    canActivate: [IsNotAuthenticatedGuard], // Guard to check if the user is NOT authenticated
    loadChildren: () => import('./core/auth/auth.module').then((m) => m.AuthModule), // Lazy load the AuthModule
  },
  {
    path: '', // Route path for the main application (root path)
    canActivate: [IsAuthenticatedGuard], // Guard to check if the user is authenticated
    loadChildren: () => import('./core/layout/layout.module').then((m) => m.LayoutModule), // Lazy load the LayoutModule
  },
  // NEW ORGANIZATION ROUTES (with client context in URL)
  {
    path: 'org/:clientId/auth', // Organization authentication routes
    canActivate: [IsNotAuthenticatedGuard],
    loadChildren: () => import('./core/auth/auth.module').then((m) => m.AuthModule),
    data: { hasClientContext: true }, // Flag to indicate org context
  },
  {
    path: 'org/:clientId', // Organization main routes
    canActivate: [IsAuthenticatedGuard],
    loadChildren: () => import('./core/layout/layout.module').then((m) => m.LayoutModule),
    data: { hasClientContext: true },
  },
  {
    path: 'marketplace', // Marketplace routes (public)
    loadChildren: () => import('./modules/marketplace/marketplace.module').then((m) => m.MarketplaceModule),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }, // Wildcard route to redirect any undefined paths to the root path
]

@NgModule({
  imports: [RouterModule.forRoot(routes)], // Import the RouterModule and configure it with the routes
  exports: [RouterModule], // Export the RouterModule so it can be used throughout the application
})
export class AppRoutingModule {} // Define and export the AppRoutingModule
